"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = void 0;
/**
 * Convenience functions for page redirection
 * @namespace   utils.redirect
 * @readonly
 */
exports.redirect = {
    /**
     * Set window URL using {@link https://developer.mozilla.org/en-US/docs/Web/API/Location/assign location.assign}
     * @memberOf utils.redirect
     * @param   {string}    newHref   URL to navigate to
     */
    set href(newHref) {
        window.location.assign(newHref);
    },
    /**
     * Get the current URL
     * @memberOf utils.redirect
     * @returns {string}
     */
    get href() {
        return window.location.href;
    },
};
//# sourceMappingURL=routing.js.map